import { Component, useEffect, useRef, useState } from 'react';
import styles from './ParamsCustom.module.css';
import useApi from '../../services/useApi';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { namespaceState, newTaskConfig } from '../../recoil/atoms';
import {additionalParameters}from '../../constants';

const ParamsCustomItem = ({ id, title, value, type, onUpdate, onDelete,required })=> {
  const [filteredParam,setFilteredParam]=useState(additionalParameters);
  const [isParamsMatch,setIsParamsMatch]=useState(false);
  const customKeyRef=useRef(null);
  const customValueRef=useRef(null);
  const [customMatchIndex,setCustomMatchIndex]=useState(null);
  const [isErr,setIsErr]=useState(false);

  const handleTitleChange = (e) => {
    onUpdate(id, e.target.value, value,required);
    // setInputTitle(e.target.value)
    setFilteredParam(additionalParameters.filter(item=>item.toLowerCase().includes(e.target.value.toLowerCase())))
  };

  const handleErr=()=>{
    setIsErr(true);
    setTimeout(() => {
      setIsErr(false);
    }, 2000);
  }

  const handleValueChange = (e) => {
    if(type.includes('int')){
      if(!/^\d*$/.test(e.target.value)){
        handleErr();
        return;
      }
    } else if(type.includes('float')){
      if(!/^[0-9]*\.?[0-9]*$/.test(e.target.value)){
        handleErr();
        return;
      }
    }
    onUpdate(id, title, e.target.value,required);
    // setInputValue(e.target.value)
  };

  const handleInputValue=(e)=>{
    if(e.key==='Enter'){
      e.preventDefault();
      // customAddRef.current.click()
    }
    else if(e.key==='Escape'){
      e.preventDefault();
      customValueRef.current.blur()
    }
  }

  const handleParamsMatchRow=(newTitle)=>{
    onUpdate(id, newTitle, value,required);
    setIsParamsMatch(false);
  }

  const handleInputKey=(e)=>{
    if(e.key==='Enter'||e.key==='Tab'){
      e.preventDefault();
      if (customMatchIndex !== null) {
        // setInputTitle(filteredParam[customMatchIndex]);
        onUpdate(id,filteredParam[customMatchIndex],value,required)
      }
      customValueRef.current.focus();
    }
    else if(e.key==='Escape'){
      e.preventDefault();
      customKeyRef.current.blur()
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setCustomMatchIndex((prevIndex) => (prevIndex !== null ? Math.max(prevIndex - 1, 0) : 0));
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      setCustomMatchIndex((prevIndex) => {
        const lastIndex = filteredParam.length - 1;
        return prevIndex !== null ? Math.min(prevIndex + 1, lastIndex) : 0;
      });
    }
  }

  return(
    <div className={styles["params-custom-item"]}>
      <div className={styles['params-custom-key-wrap']}>
        <input className={`${styles["rounds-input"]} ${styles["params-input"]}`} 
          ref={customKeyRef}
          placeholder="parameter name" 
          value={title} 
          onChange={handleTitleChange} 
          onKeyDown={handleInputKey}
          onFocus={()=>setIsParamsMatch(true)}
          onBlur={()=>setTimeout(() => {
            setIsParamsMatch(false)
          }, 100)}
          disabled={required}
        />
        { isParamsMatch && filteredParam.length!=0 &&
          <div className={styles['params-match-wrap']}>
            {filteredParam.map((item,index)=>
              <span key={item} 
              className={`${styles['params-match-row']} ${customMatchIndex==index&&styles['params-match-row-hover']}`} 
              onMouseDown={(e)=>e.preventDefault()}
              onClick={()=>handleParamsMatchRow(item)}>{item}
              </span>
            )}
          </div>
        }
      </div>
      <span>:</span>
      <input className={`${styles["rounds-input"]} ${styles["rounds-input"]}`} 
        ref={customValueRef}
        value={value} 
        placeholder="value" 
        onChange={handleValueChange} 
        onKeyDown={handleInputValue}
      />
      {!required && <button onClick={() => onDelete(id)}></button>}
      {isErr&&<span className={styles['input-err']}>
        Please check data type '{type}'
      </span>}
    </div>   
  );
};

export default function ParamsCustom(){
  const taskConfig = useRecoilValue(newTaskConfig);
  const setTaskConfig = useSetRecoilState(newTaskConfig);
  const [components, setComponents] = useState([]);
  const customAddRef=useRef(null);
  const [nsState,setNsState]=useRecoilState(namespaceState);

  useEffect(()=>{
    const newParamsCustom = components.reduce((obj,item)=>{
      obj[item.title]={
        value:item.value,
        required:item.required
      }
      return obj;
    },{});

    setTaskConfig(prevData => ({
      ...prevData,
      additionalParams: newParamsCustom,
    }));
  },[components])

  useEffect(()=>{
    //modelRegistry
    useApi.get('ngp/modelreg/mm/model/v1/recipe?modelId='+taskConfig.initialModelId+'&namespaceId='+nsState.id).then((res)=>{
      const newComponent=Object.entries(res.data.modelParameters).map(([key,value],index)=>({
        id: index, 
        title: key,
        value: value.value,
        required:true,
        type:value.type
      }))
      setTaskConfig(prevData => ({
        ...prevData,
        modelType:res.data.type,
        numOfClasses:res.data.numOfClasses,
        dropReminder:res.data.dropReminder,
      }));
      setComponents(newComponent);
    })

    // const newComponent=Object.entries(taskConfig.additionalParams).map(([key,value],index)=>({
    //   id: index, title: key,value: value.value,required:value.required
    // }))
    // setComponents(newComponent);
  },[])

  const addComponent = () => {
    const newComponent = { id: components.length==0?1:components.at(-1).id+1, title: '',value:'',required:false };
    setComponents(prevComponents => [...prevComponents, newComponent]);
  };

  const updateComponent = (id, newTitle, newValue,required) => {
    setComponents(prevComponents =>
      prevComponents.map(component =>
        component.id === id ? { ...component, title: newTitle, value: newValue,required:required } : component
      )
    );
  };

  const removeComponent = (id) => {
    setComponents(prevComponents =>prevComponents.filter(component => component.id !== id));
  };

  return(
    <>
      {/* <button className={styles['params-custom-btn-add']} ref={customAddRef} onClick={addComponent}>
        <span>Add Parameter</span>
      </button> */}
      <div className={styles["params-wrap"]}>
        {components.map((component) => (
            <ParamsCustomItem
              id={component.id}
              title={component.title}
              value={component.value}
              type={component.type}
              onUpdate={updateComponent}
              onDelete={removeComponent}
              required={component.required}
            />
        ))}
      </div>
    </>
  );
};